/**
 * Preset dropdown values for the RAMS form. Add to these freely — they're
 * just suggestion lists, no DB migration needed.
 */

export const TRADE_PRESETS = [
  'Groundworks',
  'Excavation',
  'Foundations & concrete',
  'Bricklaying',
  'Scaffolding',
  'Roofing',
  'Carpentry & joinery',
  'Drylining & plastering',
  'Plumbing',
  'Electrical',
  'Tiling',
  'Decorating',
  'Flooring',
  'Insulation',
  'Steel erection',
  'Cladding',
  'Demolition',
  'Concrete pump',
  'Telehandler / lift operations',
  'Other',
] as const;

export const HAZARD_PRESETS = [
  'Working at height',
  'Manual handling',
  'Silica dust',
  'Asbestos',
  'Electrical',
  'COSHH (chemicals)',
  'Hot works',
  'Excavation',
  'Plant / pedestrian interaction',
  'Confined spaces',
  'Loud noise (>85 dB)',
  'Hand-arm vibration (HAVS)',
  'UV exposure',
  'Slips / trips',
  'Lone working',
  'Wet weather',
  'Cold conditions',
] as const;
